import { createContext, useCallback, useContext, useEffect } from 'react'
import {
	actionLoadCommonAgents,
	actionLoadCustomAgents,
	actionLoadProviderAgents,
} from '../../store/slices/agents/agentsSlice'
import { useAppDispatch } from '../../store/utils/hooks'
import useFirebaseAuthentication from '../Firebase/hooks/useFirebaseAuthentication'
import { PrefetchingProviderProps } from './types'
import { useFeatureFlags } from '../FeatureFlags/useFeatureFlags'
import { User } from 'firebase/auth'

const PrefetchingContext = createContext({})

export const PrefetchingProvider = ({ children }: PrefetchingProviderProps) => {
	const { FRONTEND_HARDCODED_AGENT_IDS } = useFeatureFlags()
	const dispatch = useAppDispatch()
	const { authUser } = useFirebaseAuthentication()

	const fetchAgents = useCallback(() => {
		if (authUser) {
			dispatch(actionLoadCommonAgents())
			dispatch(actionLoadProviderAgents(FRONTEND_HARDCODED_AGENT_IDS))
			dispatch(actionLoadCustomAgents({ userId: (authUser as User).uid }))
		}
	}, [FRONTEND_HARDCODED_AGENT_IDS, authUser, dispatch])

	useEffect(() => fetchAgents(), [fetchAgents])

	return <PrefetchingContext.Provider value={{ fetchAgents }}>{children}</PrefetchingContext.Provider>
}

export const usePrefetching = () => useContext(PrefetchingContext)
